class Nav extends HTMLElement {
  constructor () {
    super()
    const that = this
  }

  connectedCallback () {
    this.navLinksElements = this.querySelectorAll('.nav-links-element')
    this.searchTile = this.querySelectorAll('#search')

    this.navLinksElements.forEach((element) => {
      element.addEventListener('mouseenter', () => {
        element.classList.add('active')
        this.classList.add('active-secondary-nav')
      })
      element.addEventListener('mouseleave', () => {
        element.classList.remove('active')
        this.classList.remove('active-secondary-nav')
      })
    })

    this.searchTile.forEach((element) => {
      element.addEventListener('mouseenter', () => {
        element.classList.add('active')
        this.classList.add('active-flyover')
      })
      element.addEventListener('mouseleave', () => {
        element.classList.remove('active')
        this.classList.remove('active-flyover')
      })
    })
  }
}
customElements.define('nav-component', Nav)

// Mobile navigation
class NavMobile extends HTMLElement {
  constructor () {
    super()
    this.navToggle = this.querySelector('.nav-mobile-toggle')
    this.navClose = this.querySelector('.nav-mobile-close')
  }

  connectedCallback () {
    const container = this
    this.navToggle.addEventListener('click', (e) => {
      container.classList.toggle('open')
      document.body.classList.add('nav-expanded')
    })
    this.navClose.addEventListener('click', (e) => {
      container.classList.remove('open')
      document.body.classList.remove('nav-expanded')
    })
  }
}
customElements.define('nav-mobile', NavMobile)

// Mobile drawers
document.addEventListener('DOMContentLoaded', function () {
  const mobileNavDrawers = document.querySelectorAll('.nav-mobile-body-drawer')
  if (mobileNavDrawers && mobileNavDrawers.length > 0) {
    mobileNavDrawers.forEach((item) => {
      item.addEventListener('click', function () {
        // Toggle 'active' class on the clicked item
        this.classList.toggle('active')
      })
    })
  }
})

// Track scrolling state
document.addEventListener('DOMContentLoaded', function () {
  let lastScrollY = 0
  let ticking = false

  function onScroll () {
    lastScrollY = window.scrollY
    requestTick()
  }

  function requestTick () {
    if (!ticking) {
      requestAnimationFrame(update)
    }
    ticking = true
  }

  function update () {
    if (lastScrollY > 0) {
      document.body.classList.add('scrolled')
    } else {
      document.body.classList.remove('scrolled')
    }
    ticking = false
  }

  document.addEventListener('scroll', onScroll, { passive: true })
})
